import { useMemo, useState } from "react";
import { AiDrawer, AuthGate, OpsHeader, OpsSettingsDrawer, OpsWorkspace } from "./screen/OpsCenterScreen.Sections";
import { ToolInventoryDrawer } from "./screen/OpsCenterScreen.ToolInventory";
import { useOpsCenterState } from "./hooks/useOpsCenterState";
import { opsCenterCopy, resolveLocale } from "./i18n/OpsCenter.I18n";

export function OpsCenterScreen() {
  const [locale, setLocale] = useState(() => resolveLocale(window.navigator.language));
  const copy = useMemo(() => opsCenterCopy(locale), [locale]);
  const controller = useOpsCenterState(copy);
  const { state } = controller;

  if (!state.session?.authenticated) {
    return <AuthGate {...controller} copy={copy} locale={locale} onLocaleChange={setLocale} />;
  }

  return (
    <main className="ops-shell">
      <OpsHeader {...controller} copy={copy} locale={locale} onLocaleChange={setLocale} />
      <OpsWorkspace {...controller} copy={copy} locale={locale} />
      <ToolInventoryDrawer {...controller} copy={copy} locale={locale} />
      <OpsSettingsDrawer {...controller} copy={copy} locale={locale} onLocaleChange={setLocale} />
      <AiDrawer {...controller} copy={copy} locale={locale} />
    </main>
  );
}
